var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXdcAboutCardIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0527 0C18.1034 0.0393021 26.1391 6.26397 35.7813 5.70215C35.7813 5.70215 39.3125 30.6794 17.9785 37.9922C17.9785 37.9922 -1.56845 33.2788 0.10059 5.41699C0.10059 5.41699 10.2156 6.4298 18.0527 0ZM17.8516 3.86816C10.6756 9.13726 2.74903 8.47461 2.74903 8.47461C2.74903 8.47461 2.71979 19.0433 6.45508 25.6533C10.27 32.4032 17.8516 34.8682 17.8516 34.8682C17.8873 34.8551 26.0283 31.8798 29.8076 25.1924C33.5595 18.5538 32.9578 8.60088 32.9541 8.54102C32.9541 8.54102 28.3999 9.72585 17.8516 3.86816Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.501961,
    d: "M18.0352 7C18.0352 7 23.3996 11.1237 29.8545 10.7529C29.8578 10.7761 32.1986 27.1913 17.9854 32C17.8994 31.9793 4.95837 28.8376 6.06741 10.5645C6.06741 10.5645 12.8104 11.2312 18.0352 7ZM20.9727 13.7402C20.9645 13.7487 17.7402 17.0728 16.0684 20.2246C14.6935 18.9206 14.8535 18.9078 13.9395 18.5684C13.1916 18.2913 12.427 18.4185 11.8096 18.5C11.3626 18.5584 11.4137 19.2457 11.5518 19.3281C14.447 21.0598 15.9884 25.2177 16.0039 25.2598C16.0147 25.2381 17.6548 21.9513 19.4893 19.1211C21.3591 16.236 23.4258 13.8096 23.4258 13.8096L20.9727 13.7402Z",
    fill: "#FAFAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdcAboutCardIcon2);
export default __webpack_public_path__ + "static/media/xdc-about-card-icon-2.bb2c219fb0219dc7d4c6d832e50f6c61.svg";
export { ForwardRef as ReactComponent };